import { getSpotConfig } from '@host-panel/request/config';

export async function getCssDefaultVariablesConfig(spotId: string) {
  const res: any = await getSpotConfig(spotId, [
    'tenant.css-variables-default',
    'tenant.css-variables-dark',
    'tenant.css-variables-mobile'
  ], {byNameSpace: true});
  return res;
}
